"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ScrollPositionHelper = _interopRequireDefault(require("../../../../utils/ScrollPositionHelper"));

var _HidingFixedHeaderModule = _interopRequireDefault(require("./HidingFixedHeader.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * # Hiding Fixed Header
 * A header fixed to the window that only becomes visible once the user scrolls vertically past a set trigger point
 *
 * ## Modifiers
 * ```js
 * scrollActivationDistance //Distance at which the header should become fixed to the top of the window
 * ```
 *
 * ## PropTypes:
 * ```js
 *  FBButton.propTypes = {
 *    scrollActivationDistance: PropTypes.number.isRequired,
 *    className: PropTypes.string,
 *    children: PropTypes.node,
 *  };
 * ```
 */
var HidingFixedHeader = function HidingFixedHeader(_ref) {
  var scrollActivationDistance = _ref.scrollActivationDistance,
      className = _ref.className,
      showClassOverride = _ref.showClassOverride,
      hideClassOverride = _ref.hideClassOverride,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["scrollActivationDistance", "className", "showClassOverride", "hideClassOverride", "children"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      fixHeader = _useState2[0],
      setFixHeader = _useState2[1];

  var showHeaderStyles = [_HidingFixedHeaderModule.default.FixedHeader, _HidingFixedHeaderModule.default.show, showClassOverride];
  var hideHeaderStyles = [_HidingFixedHeaderModule.default.FixedHeader, _HidingFixedHeaderModule.default.hide, hideClassOverride];
  showHeaderStyles.push(className);
  hideHeaderStyles.push(className);
  (0, _ScrollPositionHelper.default)(function (_ref2) {
    var currentPosition = _ref2.currentPosition;
    var pastScrollBoundary = currentPosition.y > scrollActivationDistance;
    var shouldFixHeader = pastScrollBoundary;

    if (shouldFixHeader !== fixHeader) {
      setFixHeader(shouldFixHeader);
    }
  }, [fixHeader], undefined, true, 100);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: fixHeader ? showHeaderStyles.join(' ') : hideHeaderStyles.join(' ')
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: _HidingFixedHeaderModule.default.FixedHeader__content
  }, children));
};

HidingFixedHeader.propTypes = {
  scrollActivationDistance: _propTypes.default.number.isRequired,
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  showClassOverride: _propTypes.default.string,
  hideClassOverride: _propTypes.default.string
};
var _default = HidingFixedHeader;
exports.default = _default;

//# sourceMappingURL=HidingFixedHeader.js.map